<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="700XAuto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @close="cancel"
      @confirm="confirm">
    <template #header>费用项管理</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
      >
        <gj-table
            :index="false"
            :data="form.expenseItems"
            :columns="columns"
            :adapt-height="false"
            :height="400">
          <template v-slot:header:option>
            <gj-button
                type="iconfont"
                iconfont="iconzengjia"
                size="20px"
                @click="addExpenses">
            </gj-button>
          </template>
          <template v-slot:feeItemName="{index}">
            <el-form-item
                :prop="`expenseItems.${index}.feeItemName`"
                :rules="[{required: true, message: '费用项名称不能为空', trigger: ['change', 'blur']}]"
            >
              <gj-input
                  v-model="form.expenseItems[index].feeItemName"
                  width="100%"
              ></gj-input>
            </el-form-item>
          </template>
          <template v-slot:option="{index,row}">
            <gj-button v-if="row.canDelete !== false"
                       type="iconfont"
                      iconfont="iconjianshao"
                      size="20px"
                       @click="delExpenses(index,row)">
            </gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import _ from "lodash"
import { addOrUpdateFeeItem } from "@/api/finance"
import {formValidatorMixin, modalMixIn, responseMixin} from "@/minxins";

export default {
  name: "expense-management-items",
  mixins: [modalMixIn, formValidatorMixin, responseMixin],
  props: {
    tableData:{
      type: Array,
    },
    tabsActive:{
      type: String,
    }
  },
  data(){
    return {
      confirmLoading: false,
      // 费用项表单数据，无上限
      form:{
        expenseItems: [],
      },
      columns: [
        {id: 'feeItemName', header: '费用项名称', field: 'slot:feeItemName', minWidth: '300px', fixed: 'center'},
        {id: 'option', header: 'slot:option', field: 'slot:option', width: '60px', fixed: 'right'},
      ]
    }
  },
  mounted(){
    this.form.expenseItems = this._.cloneDeep(this.tableData);
  },
  methods:{
    confirm(){
      this.$refs.form.validate((valid) => {
        if(valid){
          addOrUpdateFeeItem(this.form.expenseItems).then((res) =>{
            if(res.code ===0 && res.data){
              this.$gjResponseHandle(res, () => {
                this.$emit("imported",this.form.expenseItems);
                this.$emit("cenceled",this.form.expenseItems);
                this.$gjDestroy();
              });
            }else{
              this.$gjMessage.error(res.msg || '网络错误，请重试');
            }
          })
        }
      });
    },
    cancel(){
      this.$gjDestroy();
    },
    addExpenses(){
      const item = {
        feeItemName: "",
      }
      this.form.expenseItems.push(item);
    },
    delExpenses(index,row){
      this.form.expenseItems = _.filter(this.form.expenseItems,(v,idx)=>idx !==index);
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item{
  margin-top: 12px;
  margin-bottom: 12px;
}
/deep/ .el-form-item__error{
  margin-top: -10px;
  padding-top: 0;
}
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
</style>

